module.exports = __webpack_public_path__ + "img/bot2.fa845911.jpeg";